import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; // Debe ser App, no Dashboard
import reportWebVitals from './reportWebVitals';
import './chartSetup';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();